import React, { useState } from 'react';
import './ConfirmDialog.css';
import emailjs from '@emailjs/browser';
import { toast } from 'react-toastify';

const ContactSupport = ({ contactOpen, title, username, useremail, onCancel }) => {
  const [formData, setFormData] = useState({
    username: username || '',
    email: useremail || '',
    category: '',
    message: ''
  });

  const [isLoading, setIsLoading] = useState(false); // ✅ New loading state

  const SERVICE_ID = 'service_ma9nr3c';
  const TEMPLATE_ID = 'template_qgvlztn';
  const PUBLIC_KEY = 'DlJwdfxB90oWSDIq4';

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true); // ✅ Start spinner

    emailjs.send(SERVICE_ID, TEMPLATE_ID, formData, PUBLIC_KEY)
      .then(() => {
        toast.success('Your message has been sent!');
        setFormData({ category: '', message: ''});
        setIsLoading(false); // ✅ Stop spinner
        onCancel(); // ✅ Close dialog after successful send
      })
      .catch((error) => {
        console.error('Email sending failed:', error);
        toast.error('Failed to send message. Please try again.');
        setIsLoading(false); // ✅ Stop spinner even if failed
      });
  };

/*  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs.send(SERVICE_ID, TEMPLATE_ID, formData, PUBLIC_KEY)
      .then(() => {
        setSuccess('Thank you for reaching out! Your message has been sent.');
        setFormData({ category: '', message: '' });
        contactOpen(false); // Close the dialog after sending
      })
      .catch((error) => {
        console.error('Email sending failed:', error);
        setSuccess('Something went wrong. Please try again later.');
      });
  };*/

  if (!contactOpen) return null;

  return (
    <div className="confirm-dialog-overlay">
      <div className="contact-dialog-box">
        <h3>{title}</h3>
        <form onSubmit={handleSubmit}>
          <p>User Name: {username}</p>

          <label>Category</label>
          <select
            name="category"
            value={formData.category}
            onChange={handleChange}
            required
          >
            <option value="">Select Category</option>
            <option value="Account Related">Account Related</option>
            <option value="Billing">Billing</option>
            <option value="Customer Data">Customer Data</option>
            <option value="Request Deletion">Request Deletion</option>
            <option value="Other">Other</option>
          </select>

          <label>Message details</label>
          <textarea
            name="message"
            placeholder="Please enter your message here"
            rows="3"
            value={formData.message}
            onChange={handleChange}
            required
          />

          <div className="dialog-buttons">
            <button type="submit" className="contact-button" disabled={isLoading}>
              {isLoading ? 'Sending...' : 'Send Message'}
            </button>
            <button type="button" className="cancel-btn" onClick={onCancel} disabled={isLoading}>
              Close
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContactSupport;
